'use client';

import { CategoryLink } from '@/sanity/fetchCategories';
import Heart from '../base/Heart';
import Tag from '../base/Tag';
import TripleLines from '../base/TripleLines';
import { useBreakpoints } from '@/utils/useBreakpoints';
import styles from './CategoriesGrid.module.scss';

interface CategoriesGridProps {
  categories: CategoryLink[];
  title: string;
  caption: string;
  className?: string;
}

export default function CategoriesGrid({
  categories,
  title,
  caption,
  className,
}: CategoriesGridProps) {
  const { isLg } = useBreakpoints();

  return (
    <div className={className}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            <TripleLines variant="topRight">{title}</TripleLines>
          </h2>
          <p className={styles.subtitle}>{caption}</p>
        </div>

        <div className={styles.tagGrid}>
          {categories?.map((category) => (
            <Tag
              label={category.name}
              href={category.linkPath}
              size={isLg ? 'md' : 'sm'}
              key={category._id}
            />
          ))}
        </div>
        <div className={styles.heartWrapper}>
          <Heart amount={1} />
        </div>
      </div>
    </div>
  );
}
